import React from 'react';
import { Modal, Select, Form, InputNumber } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './FirmnessTesterConversion.css';
import Translation from '../../Translation';

const FormItem = Form.Item;
const Option = Select.Option;

/**
 * Class for firmness tester conversion.
 *
 * @class FirmnessTesterConversion
 * @extends {React.Component}
 */
class FirmnessTesterConversion extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            circDisabled: true,
            diameterDisabled: true,
            conversion: '',
            firmnessCurrent: 0,
            firmnessNew: 0,
            circumferenceCurrent: 0,
            circumferenceNew: 0,
            diameterCurrent: 0,
            diameterNew: 0,
            depressionCurrent: 0,
            depressionNew: 0,
            firmnessData: []
        };

        this.handleCurrentTestChange = this.handleCurrentTestChange.bind(this);
        this.handleNewTestChange = this.handleNewTestChange.bind(this);
        this.handleClear = this.handleClear.bind(this);
    }

    componentDidMount() {
        if (this.props.prefData.preferences.size === 1) {
            this.setState({
                circDisabled: false
            });
        }
        else if (this.props.prefData.preferences.size === 2) {
            this.setState({
                diameterDisabled: false
            });
        }
    }

    /**
     * handleSubmit function, calculates and sets the value for new firmness, current depression and new depression
     * @param {*} e here e is an event passed
     * @memberof FirmnessTesterConversion
     */
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                var currentTestMethod = this.state.currentTest;
                var newTestMethod = this.state.newTest;

                let firmnessCur = values.firmnessCurrent;
                let firmnessNew = 0;
                let circCur = values.circumferenceCurrent;
                let diaCur = values.diameterCurrent;

                let depCur = 0, depNew = 0;

                depCur = diaCur * (1 - firmnessCur / 100);


                switch (currentTestMethod) {
                    case 'Filtrona QTM':
                        depCur = (depCur - 0.0685) / 1.436;
                        break;
                    case 'Manual Filtrona':
                        depCur = 1.003 * depCur - 0.0658;
                        break;
                    case 'Borgwaldt':
                        depCur = 1.028 * depCur - 0.626;
                        break;
                    case 'Borgwaldt 1 Kg':
                        depCur = 0.74 * depCur - 0.465
                        break;
                    default:
                    //do nothing
                }


                switch (newTestMethod) {
                    case 'Filtrona QTM':
                        depNew = 1.436 * depCur + 0.0685
                        break;
                    case 'Manual Filtrona':
                        depNew = (depCur + 0.0658) / 1.003;
                        break;
                    case 'Borgwaldt':
                        depNew = (depCur + 0.626) / 1.028;
                        break;
                    case 'Borgwaldt 1 Kg':
                        depNew = (depCur + 0.465) / 0.74
                        break;
                    default:
                        depNew = depCur;
                }

                firmnessNew = (1 - depNew / diaCur) * 100;

                this.props.form.setFieldsValue({
                    firmnessNew: firmnessNew.toFixed(2),
                    circumferenceNew: circCur,
                    diameterNew: diaCur,
                    depressionCurrent: depCur.toFixed(2),
                    depressionNew: depNew.toFixed(2)
                });
            }
        });
    }

    /**
     * handleClear function is for clearing the fields on the form
     * 
     * @memberof FirmnessTesterConversion
     */
    handleClear() {
        this.props.form.resetFields();
        this.setState({
            conversion: ''
        });
    }

    /**
     * handleCurrentTestChange function, selects the method from the dropdown and sets the state for the same.
     * @param {String} value name of the method selected
     * @memberof FirmnessTesterConversion
     */
    handleCurrentTestChange(value) {
        this.setState({
            currentTest: value
        });
    }

    /**
     * handleNewTestChange function, selects the method from the dropdown and sets the state for the same.
     * @param {String} value name of the method selected
     * @memberof FirmnessTesterConversion
     */
    handleNewTestChange(value) {
        this.setState({
            newTest: value
        });
    }

    /**
     * handleCancel function, closes the firmness conversion window
     * 
     * @memberof FirmnessTesterConversion
     */
    handleCancel() {
        this.props.showFirmnessTesterScreen(false);
    }

    /**
     * validateDiameter function validates the current circumference field
     * @param {} rule
     * @param {String} value, it is the value user types in the field
     * @param {} callback
     * @memberof FirmnessTesterConversion
     */
    validateCircumference = (rule, value, callback) => {
        if (value && (value < 16.5 || value > 27)) {
            callback(<Translation labelName="msg_error_plz_enter_circumference_value" defaultText="Please enter circumference between 16.5 and 27mm"/>);
        }
        else {
            callback();
        }
    }

    /**
     * validateDiameter function validates the current diameter field
     * @param {} rule
     * @param {String} value, it is the value user types in the field
     * @param {} callback
     * @memberof FirmnessTesterConversion
     */
    validateDiameter = (rule, value, callback) => {
        if (value && (value < 5.3 || value > 8.5)) {
            callback(<Translation labelName="msg_error_plz_enter_diameter_value" defaultText="Please enter diameter between 5.3 and 8.5"/>);
        }
        else {
            callback();
        }
    }

    /**
     * validateDiameter function validates the current firmness field
     * @param {} rule
     * @param {String} value, it is the value user types in the field
     * @param {} callback
     * @memberof FirmnessTesterConversion
     */
    validateFirmness = (rule, value, callback) => {
        if (value && (value < 70 || value > 100)) {
            callback(<Translation labelName="msg_error_firmness_value" defaultText="Firmness % must be between 70 and 100"/>);
        }
        else {
            callback();
        }
    }

    /**
     * handleChangeCalculateCircDiameter function sets the diameter or the circumference depending upon the user preference.
     * @param {String} value it is the value user types in the field
     * @memberof FirmnessTesterConversion
     */
    handleChangeCalculateCircDiameter = (value) => {
        const pi = Math.PI;

        if (value && this.state.circDisabled) {
            let circumference = (pi * value).toFixed(2);
            this.props.form.setFieldsValue({
                circumferenceCurrent: circumference
            });
        }
        else if (value && this.state.diameterDisabled) {
            let diameter = (value / pi).toFixed(2);
            this.props.form.setFieldsValue({
                diameterCurrent: diameter
            });
        }
        else {
            this.props.form.resetFields(['circumferenceCurrent', 'diameterCurrent']);
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div className="firmness-wrapper">
                <Modal
                    title={<Translation labelName="title_tools_firmsness_tester" defaultText="Firmness Tester Conversion" />}
                    visible={this.props.isFirmnessTesterVisible}
                    footer={null}
                    width="40%"
                    centered
                    style={{ top: 20 }}
                    onCancel={() => this.handleCancel()}>
                    <div className="ant-layout-content">
                        <div className='firmness-container'>
                            {/* <a href='/help/html/Firmness_Tester_Correlation_Study.htm' title="Help" target="_blank" className="help-section">
                                <img
                                    src="./images/help-inverse-black.svg"
                                    alt="help"
                                    className="help-icon" />
                            </a> */}
                            <Form>
                                <div className="row firmness-row-wrapper">
                                    <div className="col-md-12">
                                        <div className="col-md-offset-3 col-md-9">
                                            <label className="firmness-row-current col-md-6"><Translation labelName="lbl_current_firmness_test" defaultText="Current Firmness Test" /></label>
                                            <label className="firmness-row-new col-md-6"><Translation labelName="lbl_firmness_test" defaultText="New Firmness Test" /></label>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <label className="col-md-3 firmness-labels"></label>
                                        <div className="col-md-9 firmness-fields">
                                            <div className="firmness-form-item">
                                                <FormItem>
                                                    <Select
                                                        placeholder={<Translation labelName="lbl_select_method" defaultText="Select a method" />}
                                                        value={this.state.currentTest}
                                                        onChange={this.handleCurrentTestChange}
                                                        className="firmness-container__select">
                                                        <Option value="Filtrona FTS"><Translation labelName="txt_filtrona_fts" defaultText="Filtrona FTS"/></Option>
                                                        <Option value="Filtrona QTM"><Translation labelName="txt_filtrona_qtm" defaultText="Filtrona QTM"/></Option>
                                                        <Option value="Filtrona DHT"><Translation labelName="txt_filtrona_dht" defaultText="Filtrona DHT"/></Option>
                                                        <Option value="Manual Filtrona"><Translation labelName="txt_manual_filtrona" defaultText="Manual Filtrona"/></Option>
                                                        <Option value="Borgwaldt"><Translation labelName="txt_borgwaldt" defaultText="Borgwaldt"/></Option>
                                                        <Option value="Borgwaldt 1 Kg"><Translation labelName="txt_borgwaldt_1kg" defaultText="Borgwaldt w/1 kg wt"/></Option>
                                                    </Select>
                                                </FormItem>
                                            </div>
                                            <div className="firmness-form-item">
                                                <FormItem>
                                                    <Select
                                                        placeholder={<Translation labelName="lbl_select_method" defaultText="Select a method" />}
                                                        value={this.state.newTest}
                                                        onChange={this.handleNewTestChange}
                                                        className="firmness-container__select">
                                                        <Option value="Filtrona FTS"><Translation labelName="txt_filtrona_fts" defaultText="Filtrona FTS"/></Option>
                                                        <Option value="Filtrona QTM"><Translation labelName="txt_filtrona_qtm" defaultText="Filtrona QTM"/></Option>
                                                        <Option value="Filtrona DHT"><Translation labelName="txt_filtrona_dht" defaultText="Filtrona DHT"/></Option>
                                                        <Option value="Manual Filtrona"><Translation labelName="txt_manual_filtrona" defaultText="Manual Filtrona"/></Option>
                                                        <Option value="Borgwaldt"><Translation labelName="txt_borgwaldt" defaultText="Borgwaldt"/></Option>
                                                        <Option value="Borgwaldt 1 Kg"><Translation labelName="txt_borgwaldt_1kg" defaultText="Borgwaldt w/1 kg wt"/></Option>
                                                    </Select>
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="col-md-offset-3 col-md-9">
                                            <label className="firmness-row-current col-md-6"><Translation labelName="lbl_Current" defaultText="Current"/></label>
                                            <label className="firmness-row-new col-md-6"><Translation labelName="lbl_New" defaultText="New"/></label>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <label className="col-md-3 firmness-labels"><Translation labelName="lbl_firmness" defaultText="Firmness"/> <Translation labelName="units_%" defaultText="%"/></label>
                                        <div className="col-md-9 firmness-fields">
                                            <div className="firmness-form-item">
                                                <FormItem>
                                                    {getFieldDecorator('firmnessCurrent', {
                                                        rules: [{ required: true, message: <Translation labelName="err_field_cannot_be_empty" defaultText="Field cannot be empty!"/>},
                                                        { validator: this.validateFirmness, }],
                                                    })(
                                                        <InputNumber />
                                                    )}
                                                </FormItem>
                                            </div>
                                            <div className="firmness-form-item">
                                                <FormItem>
                                                    {getFieldDecorator('firmnessNew')(
                                                        <InputNumber disabled />
                                                    )}
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row firmness-row-wrapper">
                                    <div className="col-md-12">
                                        <label className="col-md-3 firmness-labels"><Translation labelName="lbl_circumference" defaultText="Circumference"/></label>
                                        <div className="col-md-9 firmness-fields">
                                            <div className="firmness-form-item">
                                                <FormItem>
                                                    {getFieldDecorator('circumferenceCurrent', {
                                                        rules: [{ required: !this.state.circDisabled, message: <Translation labelName="err_field_cannot_be_empty" defaultText="Field cannot be empty!"/> },
                                                        { validator: this.validateCircumference, }],
                                                    })(
                                                        <InputNumber
                                                            onChange={this.handleChangeCalculateCircDiameter}
                                                            disabled={this.state.circDisabled} />
                                                    )}
                                                </FormItem>
                                            </div>
                                            <div className="firmness-form-item">
                                                <FormItem>
                                                    {getFieldDecorator('circumferenceNew')(
                                                        <InputNumber disabled />
                                                    )}
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row firmness-row-wrapper">
                                    <div className="col-md-12">
                                        <label className="col-md-3 firmness-labels"><Translation labelName="lbl_diameter" defaultText="Diameter"/></label>
                                        <div className="col-md-9 firmness-fields">
                                            <div className="firmness-form-item">
                                                <FormItem>
                                                    {getFieldDecorator('diameterCurrent', {
                                                        rules: [{ required: !this.state.diameterDisabled, message: <Translation labelName="err_field_cannot_be_empty" defaultText="Field cannot be empty!"/> },
                                                        { validator: this.validateDiameter, }],
                                                    })(
                                                        <InputNumber
                                                            onChange={this.handleChangeCalculateCircDiameter}
                                                            disabled={this.state.diameterDisabled} />
                                                    )}
                                                </FormItem>
                                            </div>
                                            <div className="firmness-form-item">
                                                <FormItem>
                                                    {getFieldDecorator('diameterNew')(
                                                        <InputNumber disabled />
                                                    )}
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row firmness-row-wrapper">
                                    <div className="col-md-12">
                                        <label className="col-md-3 firmness-labels"><Translation labelName="lbl_Depression" defaultText="Depression"/> (<Translation labelName="units_lbl_mm" defaultText="mm"/>)</label>
                                        <div className="col-md-9 firmness-fields">
                                            <div className="firmness-form-item">
                                                <FormItem>
                                                    {getFieldDecorator('depressionCurrent')(
                                                        <InputNumber disabled />
                                                    )}
                                                </FormItem>
                                            </div>
                                            <div className="firmness-form-item">
                                                <FormItem>
                                                    {getFieldDecorator('depressionNew')(
                                                        <InputNumber disabled />
                                                    )}
                                                </FormItem>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="firmness-btn-wrapper">
                                    <button
                                        value="calculate"
                                        className="btn btn-primary firmness-btn-calculate"
                                        onClick={this.handleSubmit}
                                        type="submit">
                                       <Translation labelName="btn_calculate" defaultText="CALCULATE"/>
                                    </button>
                                    <button
                                        className="btn btn-primary"
                                        onClick={this.handleClear}
                                        type="button">
                                        <Translation labelName="btn_clear" defaultText="CLEAR"/>
                                    </button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

const DefaultFirmnessTesterConversion = Form.create()(FirmnessTesterConversion);
const mapStateToProps = ({ loggedUserState }) => ({
    prefData: loggedUserState.prefData
});

export default connect(mapStateToProps, null)(DefaultFirmnessTesterConversion);

FirmnessTesterConversion.propTypes = {
    showFirmnessTesterScreen: PropTypes.func,
    isFirmnessTesterVisible: PropTypes.bool,
    form: PropTypes.object,
    prefData: PropTypes.object,
}



// WEBPACK FOOTER //
// ./src/components/FirmnessTesterConversion/index.js